import { ChainId } from '@pancakeswap/sdk'
import { Address } from 'viem'

import { SupportedChainId } from './supportedChains'

export type ContractAddresses<T extends ChainId = SupportedChainId> = {
  [chainId in T]: Address
}

export const IDACKIE = {
  // [ChainId.BSC]: '0x3C458828D1622F5f4d526eb0d24Da8C4Eb8F07b1',
  // [ChainId.BSC_TESTNET]: '0x',
  // [ChainId.ETHEREUM]: '0x',
  [ChainId.BASE_GOERLI]: '0xE89eBa0750199358244dccaFf08b5D0dB0384383',
} as const satisfies ContractAddresses<SupportedChainId>

export const DACKIE_VAULT = {
  // [ChainId.BSC]: '0x45c54210128a065de780C4B0Df3d16664f7f859e',
  // [ChainId.BSC_TESTNET]: '0x1088Fb24053F03802F673b84d16AE1A7023E400b',
  // [ChainId.ETHEREUM]: '0x',
  [ChainId.BASE_GOERLI]: '0xFb3Ac50c14bbb0071bc120C6AEfB9617f05182b5',
} as const satisfies ContractAddresses<SupportedChainId>

export const DACKIE_FLEXIBLE_SIDE_VAULT = {
  // [ChainId.BSC]: '0x615e896A8C2CA8470A2e9dc2E9552998f8658Ea0',
  // [ChainId.BSC_TESTNET]: '0x',
  // [ChainId.ETHEREUM]: '0x',
  [ChainId.BASE_GOERLI]: '0x99C716F94092BcfcFa769266a840840F0CBA8496',
} as const satisfies ContractAddresses<SupportedChainId>
